import http from "@/http/aisea/axios";

const resource = "/enterprises/radar-grid/objects";

export default {
  path(
    radarGridObjectId, // string
    params = {
      // started_at: string
      // ended_at: string
      // interval: number
    },
  ) {
    return http.get(`${resource}/${radarGridObjectId}/path`, {
      params,
    });
  },
  pathForecast(
    radarGridObjectId, // string
    params = {
      // forecast_minutes: number
    },
  ) {
    return http.get(`${resource}/${radarGridObjectId}/path/forecast`, {
      params,
    });
  },
  search(params) {
    return http.get(`${resource}/search`, {
      params,
    });
  },
};
